import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import React__default from 'react';
import clsx from 'clsx';
import { Base } from '../../Internal/Base/Base.js';
import styles from './Inline.module.css.js';

const justifyMap = {
    start: styles.justifyStart,
    end: styles.justifyEnd,
    center: styles.justifyCenter,
    between: styles.justifyBetween,
    around: styles.justifyAround,
};
const alignMap = {
    start: styles.alignStart,
    end: styles.alignEnd,
    center: styles.alignCenter,
    stretch: styles.alignStretch,
    baseline: styles.alignBaseline,
    normal: styles.alignNormal,
};
const createChildren = (children, splitAfter) => {
    if (typeof splitAfter === undefined) {
        return children;
    }
    return React__default.Children.map(children, (child, index) => {
        if (splitAfter === index && React__default.isValidElement(child)) {
            const props = {
                className: clsx(child.props.className, styles.splitAfter),
            };
            return React__default.cloneElement(child, props);
        }
        return child;
    });
};
const Inline = ({ justify = 'start', align = 'center', space, className, splitAfter, wrap = false, reverse = false, children, ...restProps }) => {
    const justifyContent = justifyMap[justify];
    const alignItems = alignMap[align];
    const clusterClassName = clsx(styles.inline, className, space && styles[space], alignItems, justifyContent, {
        [styles.isWrap]: wrap,
        [styles.isReverse]: reverse,
    });
    return (jsxRuntimeExports.jsx(Base, { className: clusterClassName, ...restProps, children: createChildren(children, splitAfter) }));
};
Inline.displayName = 'Inline';

export { Inline, alignMap, justifyMap };
//# sourceMappingURL=Inline.js.map
